export default "__VITE_ASSET__CTWbgPQX__"